import AsyncView from '@pixelunion/shopify-asyncview';
import rimg from '@pixelunion/rimg-shopify';
import ProductList from '../components/ProductList';

export default class StaticProductRecommendations {
  constructor(section) {
    this.sectionId = section.id;
    const { productId } = section.data;
    const { limit } = section.data.settings;
    const recommendationsEl = document.querySelector('[data-product-recommendations]');

    this._loadRecommendations = this._loadRecommendations.bind(this);
    this._loadRecommendations(recommendationsEl, productId, limit);
  }

  onSectionUnload() {
    if (this.productList) {
      this.productList.unload();
    }
  }

  _loadRecommendations(container, productId, limit) {
    const url = `${window.Theme.routes.product_recommendations_url}?section_id=${this.sectionId}&limit=${limit}&product_id=${productId}`;

    AsyncView.load(
      url,
      { view: '' },
    ).then(({ html }) => {
      container.innerHTML = html;

      rimg.watch(container);
      this.productList = new ProductList({ el: container, id: `shopify-section-${this.sectionId}` });

      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }
    });
  }
}
